import { defineComponent as d, computed as l, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as a, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "8dcf74db-0885-4f1a-b99d-eb393e7c8dff" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#8dcf74db-0885-4f1a-b99d-eb393e7c8dff)" }, v = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 68 68 0h376l68 68v376l-68 68H68L0 444Z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0v68l188 188L0 444v68h68l188-188 188 188h68v-68L324 256 512 68V0h-68L256 188 68 0Z"
}, null, -1), g = /* @__PURE__ */ e("circle", {
  cx: "256",
  cy: "256",
  r: "96",
  fill: "#ff9811"
}, null, -1), x = /* @__PURE__ */ e("circle", {
  cx: "256",
  cy: "256",
  r: "64",
  fill: "#6da544"
}, null, -1), y = { fill: "none" }, w = ["r"], N = /* @__PURE__ */ d({
  __name: "us-fl",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), n = l(() => 256 + t.strokeWidth / 2);
    return (b, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), i("title", v, a(t.flagName), 1)) : f("", !0),
        k,
        p,
        g,
        x
      ]),
      e("g", y, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=us-fl-4aa4d1da.js.map
